// Attempt polling must not replace the initial props that initialize the chat store.
export function retainDialogSnapshot<T extends { id: string }>(
	previous: T | undefined,
	next: T | undefined,
): T | undefined {
	return previous && next && previous.id.toLowerCase() === next.id.toLowerCase()
		? previous
		: next;
}
